import React, { useEffect, useState, useRef } from 'react';
import {
  Grid,
  Typography,
  Paper,
  Button,
  Divider,
  Box,
  Select,
  InputLabel,
  MenuItem,
  Snackbar,
  FormControl,
  TextField,
  Alert,
  Card,
  CardContent,
  Avatar,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MuiFileInput } from 'mui-file-input';

const { REACT_APP_API_BASE_URL, REACT_APP_API_KEY } = process.env;

const styles = {
  paper: {
    width: '100%',
    height: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    textAlign: 'center',
  },
};

export default function Marketing(props) {
  const [tipo, setTipo] = useState('');
  const [archivo, setArchivo] = useState('');
  const [estado, setEstado] = useState('');
  const [open, setOpen] = useState(false);
  const [templatesList, setTemplatesList] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (props.templates) {
      setTipo(props.templates[0]?.template_name);
      setTemplatesList(props.templates);
    }
  }, [props.templates]);

  useEffect(() => {
    props.getTemplates(props.profile.tenant_id, props.sucursal_id);
  }, [props.sucursal_id]);

  const downloadExcel = (template_id) => {
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", "bPwQYSdN.V5nTFZpNyEn4wzDXPUJnaBz95bJa4oXP");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${REACT_APP_API_BASE_URL}/template/excel/${template_id}`, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.blob();  // Obtener el archivo como un blob
      })
      .then(blob => {
        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'template.xlsx';  // Nombre del archivo que se descargará
        document.body.appendChild(a);  // Añadir el enlace al DOM
        a.click();  // Simular el clic en el enlace
        a.remove();  // Eliminar el enlace del DOM
        window.URL.revokeObjectURL(url);  // Liberar la URL del blob
      })
      .catch(error => console.log('error', error));
  };

  const handleSend = () => {
    const url = REACT_APP_API_BASE_URL + '/messages';
    // enviar como form, con el campo file y tipo
    var myHeaders = new Headers();
    myHeaders.append('x-api-key', REACT_APP_API_KEY);
    var formdata = new FormData();
    formdata.append('file', archivo, 'listado pacientes.xlsx');
    formdata.append('template', tipo);
    formdata.append('tenant_id', props.profile.tenant_id);
    formdata.append('sucursal_id', props.sucursal_id);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
    };
    setOpen(false);
    fetch(url, requestOptions)
      .then(response => {
        if (response.status === 200) {
          setOpen(true);
          setEstado('success');
        } else {
          setOpen(true);
          setEstado('error');
        }
      })
      .catch(error => {
        setOpen(true);
        setEstado('error');
      });
  };

  const handleChange = newValue => {
    setArchivo(newValue);
  };


  return (
    <Paper style={styles.paper}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Seleccionar tipo de formulario
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={tipo}
              label="Seleccionar tipo de formulario"
              onChange={e => setTipo(e.target.value)}>
              {templatesList.map((template, index) => (
              <MenuItem value={template.template_name} key={index}>
                {template.template_name}
              </MenuItem>
              ))}
              {/* 
              <MenuItem value={'Recordatorio de citas'}>
                Recordatorio de citas
              </MenuItem>
              <MenuItem value={'Reprogramación de citas'} disabled>
                Reprogramación de citas
              </MenuItem>
              <MenuItem value={'Información del centro médico'} disabled>
                Información del centro médico
              </MenuItem>
              <Divider/>
              <MenuItem value={'Información de estudios'} disabled>
                Información de estudios
              </MenuItem>
              <MenuItem value={'Avisos de reconsetimiento de estudios'} disabled>
                Avisos de reconsetimiento de estudios
              </MenuItem>
              <Divider/>
              <MenuItem value={'Resultados de laboratorio'} disabled>
                Resultados de laboratorio
              </MenuItem>
              <MenuItem value={'Resultados de exámenes'} disabled>
                Resultados de exámenes
              </MenuItem>
              <Divider/>
              <MenuItem value={'Envio de recetas médicas'} disabled>
                Envio de recetas médicas
              </MenuItem>
              <MenuItem value={'Envio de presupuestos'} disabled>
                Envio de presupuestos
              </MenuItem>
              <Divider/>
              <MenuItem value={'Cobranzas prejudiciales'} disabled>
                Avisos de cobranzas
              </MenuItem>
              */}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <MuiFileInput
            value={archivo}
            onChange={handleChange}
            fullWidth
            inputMode="file"
            label="Selecciona un archivo"
            title="Selecciona un archivo"
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="warning"
            fullWidth
            onClick={() => downloadExcel(templatesList.find(template => template.template_name === tipo).template_id)}>
            Descargar template
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleSend()}>
            Enviar
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity={estado === 'success' ? 'success' : 'error'}
          variant="filled"
          sx={{ width: '100%' }}>
          {estado === 'success'
            ? 'Mensaje enviado correctamente'
            : 'Error al enviar mensaje'}
        </Alert>
      </Snackbar>
    </Paper>
  );
}
